// extracted by mini-css-extract-plugin
export var statItem = "_cr-1";
export var statsRow = "_cr-0";